import React, { useEffect, useState } from 'react';
import GoogleAuth from '../Auth/GoogleAuth';
import { api } from '../../services/api';
import styles from './Register.module.css';

/**
 * Standalone registration page (not part of the menu).
 * A manager shares the link; the candidate signs in with Google and is
 * registered into InvoicesUsersDb. Roles are then assigned by an admin.
 */
export default function RegisterPage({ user, isSignedIn, onSignIn }) {
  const [status, setStatus] = useState('idle'); // idle | working | done | already | error

  useEffect(() => {
    if (isSignedIn && user?.credential && status === 'idle') {
      setStatus('working');
      api.register(user.credential)
        .then((res) => setStatus(res.alreadyRegistered ? 'already' : 'done'))
        .catch(() => setStatus('error'));
    }
  }, [isSignedIn, user, status]);

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <img src={process.env.PUBLIC_URL + '/logo-hesed.png'} alt="חסד בלוד" className={styles.logo} />
        <h2>רישום למערכת</h2>

        {!isSignedIn && (
          <>
            <p className={styles.sub}>התחבר עם חשבון Google כדי להירשם</p>
            <div className={styles.authBtn}>
              <GoogleAuth onSignIn={onSignIn} isSignedIn={isSignedIn} />
            </div>
          </>
        )}

        {isSignedIn && status === 'working' && (
          <p className={styles.sub}>רושם אותך...</p>
        )}

        {isSignedIn && status === 'done' && (
          <div className={styles.success}>
            <div className={styles.icon}>✓</div>
            <p className={styles.msg}>הבקשה נרשמה בהצלחה.</p>
            <p className={styles.note}>פנה למנהל המערכת לקבלת הרשאות.</p>
          </div>
        )}

        {isSignedIn && status === 'already' && (
          <div className={styles.success}>
            <div className={styles.icon}>✓</div>
            <p className={styles.msg}>אתה כבר רשום במערכת.</p>
            <p className={styles.note}>אם אינך רואה את כל הדפים, פנה למנהל לקבלת הרשאות.</p>
          </div>
        )}

        {isSignedIn && status === 'error' && (
          <div className={styles.error}>
            <p className={styles.msg}>אירעה שגיאה ברישום.</p>
            <p className={styles.note}>נסה שוב מאוחר יותר או פנה למנהל.</p>
          </div>
        )}

        {isSignedIn && (status === 'done' || status === 'already') && (
          <a href={process.env.PUBLIC_URL + '/requests'} className={styles.homeLink}>למעבר למערכת</a>
        )}
      </div>
    </div>
  );
}
